<template>
  <hic-dialog width="50rem" title="菜单编辑" :visible="visible" :close-on-click-modal="false" @close="cancel" @open="open" top="10vh" modal-append-to-body>
    <el-form :model="value" :rules="comRules" ref="editor" :label-width="formLabelWidth" style="padding-right: 5rem" :disabled="value.disabled">
      <el-row>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input class="default-input" size="small" type="text" placeholder="请输入菜单名称" v-model="value.name" @change="genPinYin"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编码" prop="code">
            <el-input class="default-input" size="small" type="text" placeholder="请输入编码" v-model="value.code"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权限" prop="permissionCode">
            <el-cascader v-model="value.permissionCode" :options="permissions" :props="{ expandTrigger: 'hover', label: 'name', value: 'code', emitPath: false }" size="small"></el-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="图标" prop="icon">
            <el-input class="default-input" size="small" type="text" placeholder="请输入图标" v-model="value.icon">
              <i slot="suffix" :class="value.icon"></i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="拼音" prop="pinyin">
            <el-input class="default-input" size="small" type="text" placeholder="请输入拼音" v-model="value.pinyin"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="应用" prop="clientId">
            <hic-dict-selector dict-type="MySys" v-model="value.clientId" @change="applyChanged" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序" prop="seqNo">
            <el-input class="default-input" size="small" type="number" placeholder="请输入排序" v-model.number="value.seqNo"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="子菜单" prop="firstMenu">
            <el-switch v-model="value.firstMenu" @change="firstChange" active-text="有" inactive-text="没有"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="上级菜单" prop="firstMenuId">
            <el-select v-model="value.firstMenuId" placeholder="请选择" size="small" :disabled="firstDisabled" clearable>
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="样式" prop="menuClass">
            <el-input class="default-input" size="small" type="text" placeholder="请输入菜单样式" v-model="value.menuClass"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类型" prop="menuType">
            <el-input class="default-input" size="small" type="text" placeholder="请输入类型" v-model="value.menuType" title="类型可实现根据具体业务过滤不同菜单"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="memo">
            <el-input class="default-input" size="small" type="textarea" placeholder="请输入备注" :row="2" v-model="value.memo"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-switch v-if="value.id" v-model="value.disabled" active-text="停用" inactive-text="启用" active-color="#F56C6C" inactive-color="#67C23A" class="right-pad"></el-switch>
      <el-button type="info" @click="cancel">取 消</el-button>
      <!-- <el-button v-if="!value.id" type="primary" @click="saveAndNext" :disabled="disabledSaveAndNext">保存并继续新建</el-button> -->
      <el-button type="primary" @click="save" :disabled="isSaving">确 定</el-button>
    </div>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  import { pinyin as py } from "../../../packages/masterdata";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      value: Object,
      visible: Boolean,
    },
    data() {
      return {
        loading: false,
        formLabelWidth: "120px",
        // disabledSaveAndNext: false,
        isSaving: false,
        options: {},
        firstDisabled: true,
        comRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" },
            { max: 128, message: "名称长度在 128 个字符以内", trigger: "blur" },
          ],
          permissionCode: [{ required: true, message: "请输入编码", trigger: "blur" }],
          icon: [{ required: true, message: "请输入图标", trigger: "blur" }],
          clientId: [{ required: true, message: "请选择应用", trigger: "blur" }],
          seqNo: [{ required: true, type: "number", message: "排序只允许是数字", trigger: "blur" }],
          code: [
            { required: true, message: "请输入文件夹名", trigger: "blur" },
            { max: 64, message: "文件夹名长度在 64 个字符以内", trigger: "blur" },
          ],
        },
      };
    },
    computed: {
      ...mapGetters(["dict", "user"]),
      isMaster() {
        return this.user.tenantId == 1
      },
      sys() {
        if (this.isMaster && this.value.clientId) {
          return this.dict.Sys.find((s) => s.code == this.value.clientId)
        }
        if (this.value.clientId && this.dict.MySys && this.dict.MySys.length) {
          return this.dict.MySys.find((s) => s.code == this.value.clientId);
        }
        return null;
      },
      permissions() {
        return this.$utils.PermissionTree.make(this?.sys?.permissions);
      },
    },
    methods: {
      open() {
        // this.disabledSaveAndNext = false;
        this.isSaving = false;
        if (this.value.clientId && this.value.firstMenu != true) {
          this.firstDisabled = false;
          this.firstItems();
        }
      },
      save() {
        let _this = this;
        this.$refs.editor
          .validate()
          .then((valid) => {
            // _this.disabledSaveAndNext = true;
            _this.isSaving = true;
            return api.Menus.save(_this.value);
          })
          .then((res) => {
            // _this.disabledSaveAndNext = false;
            _this.isSaving = false;
            _this.$message.success("保存成功！");
            _this.$emit("ok", _this.value);
            this.$emit("update:visible", false);
          })
          .catch((err) => {
            if (err) {
              _this.$message.error(err.message || err);
            }
            // _this.disabledSaveAndNext = false;
            _this.isSaving = false;
          });
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      genPinYin() {
        this.$set(this.value, "pinyin", py.chnToFirstLetter(this.value.name));
      },
      applyChanged(val) {
        if (val != "" && val != null && this.value.firstMenu != true) {
          this.firstDisabled = false;
        } else {
          this.firstDisabled = true;
        }
        if (val) {
          this.firstItems();
        }
      },
      firstChange(val) {
        if (val != true && this.value.clientId) {
          this.firstDisabled = false;
        } else {
          this.firstDisabled = true;
        }
      },
      firstItems() {
        var para = { clientId: this.value.clientId, firstMenu: true, pageIndexOnView: 1, pageSize: 20 };
        let _this = this;
        api.Menus.query(para).then((res) => {
          _this.options = res.items;
        });
      },
    },
  };
</script>
